import { createSelector } from 'reselect'
import getCanShowLoyaltyEsimBenefitSelector from 'loyalty/selectors/getCanShowLoyaltyEsimBenefitSelector'
import getIsCheckoutEsimInternationalTrip from './getIsCheckoutEsimInternationalTrip'
import getIsCheckoutModeEligibleForLoyaltyEsim from './getIsCheckoutModeEligibleForLoyaltyEsim'

const getCanShowLoyaltyEsimBenefitForCheckoutTrip = getCanShowLoyaltyEsimBenefitSelector(
  (state: App.State) => getIsCheckoutEsimInternationalTrip(state),
)

/** Complimentary loyalty eSIM benefit eligibility. */
const getCanShowCheckoutLoyaltyEsimBenefit = createSelector(
  (state: App.State) => getCanShowLoyaltyEsimBenefitForCheckoutTrip(state),
  (state: App.State) => getIsCheckoutModeEligibleForLoyaltyEsim(state),
  (
    canShowLoyaltyEsimBenefitForTrip,
    isCheckoutModeEligibleForLoyaltyEsim,
  ): boolean => canShowLoyaltyEsimBenefitForTrip && isCheckoutModeEligibleForLoyaltyEsim,
)

export default getCanShowCheckoutLoyaltyEsimBenefit
